//#region src/translation-file.ts
function createTranslationFile(translationsByLanguage) {
	function getByLanguage(language) {
		const translationModule = translationsByLanguage[language];
		if (!translationModule) throw new Error(`Attempted to retrieve translations for unknown language "${language}"`);
		return translationModule;
	}
	return {
		getLoadedMessages(language, locale) {
			return getByLanguage(language).getValue(locale || language) || null;
		},
		getMessages(language, locale) {
			const translationModule = getByLanguage(language);
			return translationModule.load().then(() => {
				const result = translationModule.getValue(locale || language);
				if (!result) throw new Error(`Unable to find translations for ${language} after attempting to load. Module may have failed to load or an internal error may have occurred.`);
				return result;
			});
		},
		load(language) {
			return getByLanguage(language).load();
		}
	};
}

//#endregion
export { createTranslationFile };
//# sourceMappingURL=translation-file-Dn19n2oY.mjs.map